import { render, staticRenderFns } from "./FormMoeda.vue?vue&type=template&id=59b06504"
import script from "./FormMoeda.vue?vue&type=script&lang=js"
export * from "./FormMoeda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports